module.exports = require("@swa-ui/personas/defines");